import { render } from "./TreatmentCard.vue?vue&type=template&id=59d19ea2&scoped=true"
import script from "./TreatmentCard.vue?vue&type=script&lang=js"
export * from "./TreatmentCard.vue?vue&type=script&lang=js"

import "./TreatmentCard.vue?vue&type=style&index=0&id=59d19ea2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59d19ea2"]])

export default __exports__